var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.env === 'production' && _vm.todayAnniversary)?_c('div',{staticClass:"p-1 text-center text-uppercase label-indicator anniversaries"},[_vm._v(" Souhaitons un bon anniversaire à "),_c('u',[_vm._v(_vm._s(_vm.todayAnniversary.name))]),_vm._v(" (le "+_vm._s(_vm.todayAnniversary.day.format('DD/MM'))+") ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }